// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__rLdjM","load5":"Spinner_load5__2hI82"};